import Vuex from "vuex";
import Vue from "vue";
import OAuth2Store from "@/stores/OAuth2Store";
import snackbar from "@/stores/snackbar";
import fichiers from "@/stores/fichiers";
import utilisateur from "@/stores/utilisateur";
import modificationAssociation from "@/stores/modificationAssociation";
import makeStoreFields from "@/stores/makeStoreFields";

import {typeRequetes} from "@/filters/typerequete";
import {etatRequetes} from "@/filters/etatrequete";

import { oauth2Service, associationService, requeteService, snackbarService } from "@/services";
import { makePaginatedTable } from "@/stores/makePaginatedTable";

Vue.use(Vuex);

const OAUTH2_KEY = "oauth2";
export default new Vuex.Store({
    modules: {
        [OAUTH2_KEY]: OAuth2Store,
        snackbar,
        fichiers,
        utilisateur,
        modificationAssociation,
        login: makeStoreFields({ redirectTo: null }, "login.store", {
            getters: {
                email(state) {
                    return state.redirectTo?.query?.email;
                },
            }
        }),
        tables: {
            namespaced: true,
            modules: {
                associations: makePaginatedTable(
                    associationService.listeAssociations.bind(associationService)
                    , { numero: null, nom: null, etats: null, commune: null, codePostal: null, adresse: null, volume: null, folio: null, tribunal: null, mes: false }, { sort: [{ name: "tribunal", asc: true }] }),
                requetes: makePaginatedTable(
                    requeteService.listeRequetes.bind(requeteService)
                    , { numero: null, denomination: null, etats: etatRequetes(), types: typeRequetes(),  datePreEnregistrement: null}, { sort: [{ name: "datePreEnregistrement", asc: false }] }),

            }
        }
    },
    plugins: [oauth2Service.createVuexPlugin(OAUTH2_KEY), snackbarService.createVuexPlugin()],
});
